import React, { useCallback, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './SkipLink.scss';

const SKIP_LINKS = [
    { key: 'MAIN_CONTENT', selector: 'main', alwaysVisible: true },
    { key: 'SEARCH', selector: '#recherche', desktopOnly: true },
    { key: 'NAVIGATION', selector: '#menu', desktopOnly: true },
    { key: 'FOOTER', selector: '#pied-de-page' }
];

/**
 * Composant d'accessibilité
 * Liens d’accès rapide vers le contenu principal du site.
 * Masqués visuellement, s'affichent à la prise de focus clavier.
 * Seuls les liens dont la cible existe sur la page courante sont rendus
 * (les pages du funnel eBon n'ont ni recherche, ni menu, ni pied de page).
 */
const SkipLink = ({ i18n, location }) => {
    const [availableSelectors, setAvailableSelectors] = useState([]);

    useEffect(() => {
        // Délai pour laisser React rendre la nouvelle page avant de sonder le DOM
        const timeout = setTimeout(() => {
            setAvailableSelectors(
                SKIP_LINKS.filter(({ selector }) => document.querySelector(selector)).map(
                    ({ selector }) => selector
                )
            );
        }, 100);

        return () => clearTimeout(timeout);
    }, [location]);

    const handleClick = useCallback(
        selector => e => {
            e.preventDefault();
            const target = document.querySelector(selector);
            if (target) {
                if (!target.getAttribute('tabindex')) {
                    target.setAttribute('tabindex', '-1');
                }
                target.focus();
                target.scrollIntoView({ behavior: 'smooth' });
            }
        },
        []
    );

    return (
        <nav className="skip-links" aria-label={i18n.NAV_LABEL}>
            {SKIP_LINKS.filter(
                ({ selector, alwaysVisible }) =>
                    alwaysVisible || availableSelectors.includes(selector)
            ).map(({ key, selector, desktopOnly }) => (
                <a
                    key={selector}
                    href={selector}
                    className={`skip-link${desktopOnly ? ' desktop-only' : ''}`}
                    onClick={handleClick(selector)}>
                    {i18n[key]}
                </a>
            ))}
        </nav>
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.SKIP_LINKS
});

export default withRouter(connect(mapStateToProps)(SkipLink));



// WEBPACK FOOTER //
// ./src/components/rgaa/SkipLink.js